module.exports = __webpack_public_path__ + "img/loading.318733a.png";